export const SIZER_POINTS = {
  TOP_LEFT: {value: 'top-left'},
  TOP_RIGHT: {value: 'top-right'},
  BOTTOM_RIGHT: {value: 'bottom-right'},
  BOTTOM_LEFT: {value: 'bottom-left'}
}